import {showToast} from '../store/features/Notifications/notificationsSlice';

export const GROUP_CALL_STATE = 'GROUP_CALL';

export const GROUP_CALL_BUSY_TOAST = {
    title: "You're in a room call",
    description: 'Leave the room call before starting another call.',
    type: 'error',
} as const;

export const isGroupCallActiveState = (callState: unknown): boolean => callState === GROUP_CALL_STATE;

export const blockCallDuringGroupCall = (
    callState: unknown,
    dispatch: (action: ReturnType<typeof showToast>) => unknown,
): boolean => {
    if (!isGroupCallActiveState(callState)) {
        return false;
    }
    dispatch(showToast({...GROUP_CALL_BUSY_TOAST}));
    return true;
};
